export default __webpack_public_path__ + "static/media/main-bottomimg4.d37828b6.png";